import React, { useEffect } from "react";
import { useLocation, Navigate, useNavigate } from "react-router-dom";
import Navbar from "../Components/Navbar";
import { token } from "../Secure";

export default function RouteWrapper({ childComponent }) {
  const location = useLocation();
  const isAuthenticated = token;
  const navigate = useNavigate();

  const isLoginPage =
    location.pathname === "/" || location.pathname === "/login";
  useEffect(() => {
    if (!isAuthenticated) {
      navigate("/");
    }
  }, [isAuthenticated]);

  return (
    <div>
      {isLoginPage ? null : <Navbar />}
      {childComponent}
    </div>
  );
}
